import { roundMoney } from '../../utils/money';

export type CostEntryMode = 'PER_PIECE' | 'PER_GRAM';

export type PotentialEconomics = {
  profit: number;
  marginPercent: number;
};

const parsePositive = (value: string): number | null => {
  if (value == null || value.trim() === '') return null;
  const n = parseFloat(value);
  if (!isFinite(n) || isNaN(n) || n <= 0) return null;
  return n;
};

export const toFormNumberString = (value: unknown): string => {
  if (value == null) return '';
  if (typeof value === 'number') {
    return Number.isFinite(value) ? String(value) : '';
  }
  return String(value).trim();
};

export const deriveCostPerGram = (costPrice: string, weight: string): string => {
  const piece = parsePositive(costPrice);
  const w = parsePositive(weight);
  if (piece == null || w == null) return '';
  return String(roundMoney(piece / w));
};

export const deriveCostPrice = (costPerGram: string, weight: string): string => {
  const perGram = parsePositive(costPerGram);
  const w = parsePositive(weight);
  if (perGram == null || w == null) return '';
  return String(roundMoney(perGram * w));
};

export const hasPositiveWeight = (weight: string): boolean => parsePositive(weight) != null;

export const derivePotentialEconomics = (
  costPrice: string,
  sellingPrice: string,
): PotentialEconomics | null => {
  const cost = parsePositive(costPrice);
  const sale = parsePositive(sellingPrice);
  if (cost == null || sale == null) return null;
  const profit = roundMoney(sale - cost);
  const marginPercent = roundMoney((profit / sale) * 100);
  return { profit, marginPercent };
};
